import { render } from "./CustomerCardsModal.vue?vue&type=template&id=8c136658&scoped=true"
import script from "./CustomerCardsModal.vue?vue&type=script&lang=js"
export * from "./CustomerCardsModal.vue?vue&type=script&lang=js"

import "./CustomerCardsModal.vue?vue&type=style&index=0&id=8c136658&scoped=true&lang=css"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c136658"]])

export default __exports__